import React, { PropsWithChildren } from 'react'
import * as S from './styles';

interface IBaseLayoutPDFProps {
  children: React.ReactNode;
}
const BaseHeaderPDF = ({ children }: PropsWithChildren<any>) => {
  return (
    <thead>
      <tr><th>
        {children}
      </th></tr>
    </thead>
  )
}
const BaseBodyPDF = ({ children }: PropsWithChildren<any>) => {
  return (
    <tbody>
      <tr><td>
        {children}
      </td></tr>
    </tbody>
  )
}
const BaseFooterPDF = ({ children }: PropsWithChildren<any>) => {
  return (
    <tfoot>
      <tr><td>
        <div className="footer-info">
          <div className={"page-footer"}>
            {children}
          </div>
        </div>
      </td></tr>
    </tfoot>
  )
}
const BaseLayoutContainerPDF = React.forwardRef(({ children }: IBaseLayoutPDFProps, ref: React.Ref<HTMLTableElement>) => {
  return (
    <S.TableContainer ref={ref}>
      {children}
    </S.TableContainer>
  )
});

export const BaseLayoutPDF = {
  Header: BaseHeaderPDF,
  Body: BaseBodyPDF,
  Footer: BaseFooterPDF,
  Container: BaseLayoutContainerPDF
}